import { useContext } from 'react';
import type * as React from 'react';
import { CardContext } from '../../utils/cardContext';
import { Header } from '../../components/Building/parts/Header';

export const BuildingHeader = (): React.JSX.Element => {
  const { displayName, reviewStats, specialStatusDisplay, url } = useContext(CardContext);

  return <Header title={displayName} rating={reviewStats} subtitle={specialStatusDisplay} url={url} />;
};
